import React from 'react';
import { Select, Tooltip, Group, Image } from '@mantine/core';
import { useLanguageContext, Language } from '../contexts/LanguageContext';

/**
 * Language Selector Component
 * Allows users to switch between Russian and English languages
 */
const LanguageSelector: React.FC = () => {
  const { language, setLanguage } = useLanguageContext();
  
  const languageOptions = [
    { 
      value: 'ru', 
      label: 'Русский',
      flag: '/icons/flags/ru.png'
    },
    { 
      value: 'en', 
      label: 'English',
      flag: '/icons/flags/us.png'
    }
  ];
  
  const handleLanguageChange = (value: string | null) => {
    if (value && (value === 'ru' || value === 'en')) {
      setLanguage(value as Language);
    }
  };
  
  const getCurrentFlag = () => {
    const currentOption = languageOptions.find(option => option.value === language);
    return currentOption?.flag || '/icons/flags/ru.png';
  };

  return (
    <Tooltip
      label="Select language for items and effects"
      position="bottom"
      withArrow
    >
      <Select
        value={language}
        onChange={handleLanguageChange}
        data={languageOptions.map(option => ({
          value: option.value,
          label: option.label
        }))}
        size="sm"
        style={{ minWidth: '80px' }}
        placeholder="Language"
        withCheckIcon={false}
        leftSection={
          <Image
            src={getCurrentFlag()}
            alt="Current language flag"
            w={16}
            h={12}
            fit="contain"
          />
        }
        renderOption={({ option }) => {
          const flagOption = languageOptions.find(opt => opt.value === option.value);
          return (
            <Group gap="xs">
              <Image
                src={flagOption?.flag}
                alt={`${option.value} flag`}
                w={16}
                h={12}
                fit="contain"
              />
              <span>{option.label}</span>
            </Group>
          );
        }}
      />
    </Tooltip>
  );
};

export default LanguageSelector; 